// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file smg_public_api.proto (package qb.smg, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file smg_public_api.proto.
 */
export const file_smg_public_api: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message qb.smg.StreamTournamentUpdatesRequest
 */
export type StreamTournamentUpdatesRequest = Message<"qb.smg.StreamTournamentUpdatesRequest"> & {
  /**
   * @generated from field: int32 tournamentId = 2;
   */
  tournamentId: number;
};

/**
 * Describes the message qb.smg.StreamTournamentUpdatesRequest.
 * Use `create(StreamTournamentUpdatesRequestSchema)` to create a new message.
 */
export const StreamTournamentUpdatesRequestSchema: GenMessage<StreamTournamentUpdatesRequest> = /*@__PURE__*/
  messageDesc(file_smg_public_api, 0);

/**
 * @generated from message qb.smg.StreamTournamentUpdatesReply
 */
export type StreamTournamentUpdatesReply = Message<"qb.smg.StreamTournamentUpdatesReply"> & {
  /**
   * @generated from field: qb.smg.StreamTournamentUpdatesTournamentInfo tournament = 3;
   */
  tournament?: StreamTournamentUpdatesTournamentInfo;
};

/**
 * Describes the message qb.smg.StreamTournamentUpdatesReply.
 * Use `create(StreamTournamentUpdatesReplySchema)` to create a new message.
 */
export const StreamTournamentUpdatesReplySchema: GenMessage<StreamTournamentUpdatesReply> = /*@__PURE__*/
  messageDesc(file_smg_public_api, 1);

/**
 * @generated from message qb.smg.StreamTournamentUpdatesTournamentInfo
 */
export type StreamTournamentUpdatesTournamentInfo = Message<"qb.smg.StreamTournamentUpdatesTournamentInfo"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: bool isPrivate = 3;
   */
  isPrivate: boolean;

  /**
   * @generated from field: string sponsorLogo = 4;
   */
  sponsorLogo: string;

  /**
   * @generated from field: int64 expirationDate = 8;
   */
  expirationDate: bigint;

  /**
   * @generated from field: repeated int32 prizePool = 9;
   */
  prizePool: number[];

  /**
   * @generated from field: repeated qb.smg.StreamTournamentUpdatesLeaderBoardEntry leaderboardEntries = 10;
   */
  leaderboardEntries: StreamTournamentUpdatesLeaderBoardEntry[];

  /**
   * @generated from field: repeated qb.smg.StreamTournamentUpdatesTournamentPlayerEntry players = 11;
   */
  players: StreamTournamentUpdatesTournamentPlayerEntry[];
};

/**
 * Describes the message qb.smg.StreamTournamentUpdatesTournamentInfo.
 * Use `create(StreamTournamentUpdatesTournamentInfoSchema)` to create a new message.
 */
export const StreamTournamentUpdatesTournamentInfoSchema: GenMessage<StreamTournamentUpdatesTournamentInfo> = /*@__PURE__*/
  messageDesc(file_smg_public_api, 2);

/**
 * @generated from message qb.smg.StreamTournamentUpdatesLeaderBoardEntry
 */
export type StreamTournamentUpdatesLeaderBoardEntry = Message<"qb.smg.StreamTournamentUpdatesLeaderBoardEntry"> & {
  /**
   * @generated from field: int32 rank = 1;
   */
  rank: number;

  /**
   * @generated from field: string playerUsername = 2;
   */
  playerUsername: string;

  /**
   * @generated from field: string playerFirstName = 3;
   */
  playerFirstName: string;

  /**
   * @generated from field: string playerLastName = 4;
   */
  playerLastName: string;

  /**
   * @generated from field: int32 score = 5;
   */
  score: number;

  /**
   * @generated from field: int32 shotsCompleted = 6;
   */
  shotsCompleted: number;

  /**
   * @generated from field: bool isCurrentUser = 7;
   */
  isCurrentUser: boolean;

  /**
   * @generated from field: string playerUsernameId = 8;
   */
  playerUsernameId: string;
};

/**
 * Describes the message qb.smg.StreamTournamentUpdatesLeaderBoardEntry.
 * Use `create(StreamTournamentUpdatesLeaderBoardEntrySchema)` to create a new message.
 */
export const StreamTournamentUpdatesLeaderBoardEntrySchema: GenMessage<StreamTournamentUpdatesLeaderBoardEntry> = /*@__PURE__*/
  messageDesc(file_smg_public_api, 3);

/**
 * @generated from message qb.smg.StreamTournamentUpdatesTournamentPlayerEntry
 */
export type StreamTournamentUpdatesTournamentPlayerEntry = Message<"qb.smg.StreamTournamentUpdatesTournamentPlayerEntry"> & {
  /**
   * @generated from field: string playerUsername = 2;
   */
  playerUsername: string;

  /**
   * @generated from field: string playerFirstName = 3;
   */
  playerFirstName: string;

  /**
   * @generated from field: string playerLastName = 4;
   */
  playerLastName: string;
};

/**
 * Describes the message qb.smg.StreamTournamentUpdatesTournamentPlayerEntry.
 * Use `create(StreamTournamentUpdatesTournamentPlayerEntrySchema)` to create a new message.
 */
export const StreamTournamentUpdatesTournamentPlayerEntrySchema: GenMessage<StreamTournamentUpdatesTournamentPlayerEntry> = /*@__PURE__*/
  messageDesc(file_smg_public_api, 4);

/**
 * @generated from message qb.smg.GetNearestSimulatorsRequest
 */
export type GetNearestSimulatorsRequest = Message<"qb.smg.GetNearestSimulatorsRequest"> & {
};

/**
 * Describes the message qb.smg.GetNearestSimulatorsRequest.
 * Use `create(GetNearestSimulatorsRequestSchema)` to create a new message.
 */
export const GetNearestSimulatorsRequestSchema: GenMessage<GetNearestSimulatorsRequest> = /*@__PURE__*/
  messageDesc(file_smg_public_api, 5);

/**
 * @generated from message qb.smg.GetNearestSimulatorsReply
 */
export type GetNearestSimulatorsReply = Message<"qb.smg.GetNearestSimulatorsReply"> & {
  /**
   * @generated from field: repeated qb.smg.NearestSimulatorDevice devices = 1;
   */
  devices: NearestSimulatorDevice[];
};

/**
 * Describes the message qb.smg.GetNearestSimulatorsReply.
 * Use `create(GetNearestSimulatorsReplySchema)` to create a new message.
 */
export const GetNearestSimulatorsReplySchema: GenMessage<GetNearestSimulatorsReply> = /*@__PURE__*/
  messageDesc(file_smg_public_api, 6);

/**
 * @generated from message qb.smg.NearestSimulatorDevice
 */
export type NearestSimulatorDevice = Message<"qb.smg.NearestSimulatorDevice"> & {
  /**
   * @generated from field: int32 device_id = 1;
   */
  deviceId: number;

  /**
   * @generated from field: int32 venue_id = 2;
   */
  venueId: number;

  /**
   * @generated from field: string venue_name = 3;
   */
  venueName: string;

  /**
   * @generated from field: string venue_address = 4;
   */
  venueAddress: string;
};

/**
 * Describes the message qb.smg.NearestSimulatorDevice.
 * Use `create(NearestSimulatorDeviceSchema)` to create a new message.
 */
export const NearestSimulatorDeviceSchema: GenMessage<NearestSimulatorDevice> = /*@__PURE__*/
  messageDesc(file_smg_public_api, 7);

/**
 * @generated from message qb.smg.GetNearestActivitiesRequest
 */
export type GetNearestActivitiesRequest = Message<"qb.smg.GetNearestActivitiesRequest"> & {
};

/**
 * Describes the message qb.smg.GetNearestActivitiesRequest.
 * Use `create(GetNearestActivitiesRequestSchema)` to create a new message.
 */
export const GetNearestActivitiesRequestSchema: GenMessage<GetNearestActivitiesRequest> = /*@__PURE__*/
  messageDesc(file_smg_public_api, 8);

/**
 * @generated from message qb.smg.GetNearestActivitiesReply
 */
export type GetNearestActivitiesReply = Message<"qb.smg.GetNearestActivitiesReply"> & {
  /**
   * @generated from field: repeated qb.smg.Activity activities = 1;
   */
  activities: Activity[];
};

/**
 * Describes the message qb.smg.GetNearestActivitiesReply.
 * Use `create(GetNearestActivitiesReplySchema)` to create a new message.
 */
export const GetNearestActivitiesReplySchema: GenMessage<GetNearestActivitiesReply> = /*@__PURE__*/
  messageDesc(file_smg_public_api, 9);

/**
 * @generated from message qb.smg.Activity
 */
export type Activity = Message<"qb.smg.Activity"> & {
  /**
   * @generated from field: string userDisplayName = 1;
   */
  userDisplayName: string;

  /**
   * Deprecated: raw cents are no longer populated by the public API (the
   * website-public-api service returns amountDisplay instead and leaves this
   * unset). Kept for wire compatibility with core's legacy handler until that
   * is retired; new consumers should read amountDisplay.
   *
   * @generated from field: int64 wonAmount = 2 [deprecated = true];
   * @deprecated
   */
  wonAmount: bigint;

  /**
   * @generated from field: bool isHoleInOne = 3;
   */
  isHoleInOne: boolean;

  /**
   * Display-formatted amount (e.g. "$50"), masked/formatted server-side.
   *
   * @generated from field: string amountDisplay = 4;
   */
  amountDisplay: string;
};

/**
 * Describes the message qb.smg.Activity.
 * Use `create(ActivitySchema)` to create a new message.
 */
export const ActivitySchema: GenMessage<Activity> = /*@__PURE__*/
  messageDesc(file_smg_public_api, 10);

/**
 * @generated from message qb.smg.GetRecentWinsRequest
 */
export type GetRecentWinsRequest = Message<"qb.smg.GetRecentWinsRequest"> & {
  /**
   * @generated from field: int32 limit = 1;
   */
  limit: number;
};

/**
 * Describes the message qb.smg.GetRecentWinsRequest.
 * Use `create(GetRecentWinsRequestSchema)` to create a new message.
 */
export const GetRecentWinsRequestSchema: GenMessage<GetRecentWinsRequest> = /*@__PURE__*/
  messageDesc(file_smg_public_api, 11);

/**
 * @generated from message qb.smg.GetRecentWinsReply
 */
export type GetRecentWinsReply = Message<"qb.smg.GetRecentWinsReply"> & {
  /**
   * @generated from field: repeated qb.smg.RecentWin wins = 1;
   */
  wins: RecentWin[];
};

/**
 * Describes the message qb.smg.GetRecentWinsReply.
 * Use `create(GetRecentWinsReplySchema)` to create a new message.
 */
export const GetRecentWinsReplySchema: GenMessage<GetRecentWinsReply> = /*@__PURE__*/
  messageDesc(file_smg_public_api, 12);

/**
 * @generated from message qb.smg.RecentWin
 */
export type RecentWin = Message<"qb.smg.RecentWin"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string playerDisplayName = 2;
   */
  playerDisplayName: string;

  /**
   * @generated from field: string amountDisplay = 3;
   */
  amountDisplay: string;

  /**
   * @generated from field: string venueName = 4;
   */
  venueName: string;

  /**
   * @generated from field: string city = 5;
   */
  city: string;

  /**
   * @generated from field: string state = 6;
   */
  state: string;

  /**
   * Unix timestamp in seconds.
   *
   * @generated from field: int64 occurredAt = 7;
   */
  occurredAt: bigint;
};

/**
 * Describes the message qb.smg.RecentWin.
 * Use `create(RecentWinSchema)` to create a new message.
 */
export const RecentWinSchema: GenMessage<RecentWin> = /*@__PURE__*/
  messageDesc(file_smg_public_api, 13);

/**
 * @generated from message qb.smg.GetLocationFinderVenuesRequest
 */
export type GetLocationFinderVenuesRequest = Message<"qb.smg.GetLocationFinderVenuesRequest"> & {
  /**
   * User location from browser geolocation.
   * If provided, use it to return nearby venues and calculate distance_miles.
   * If absent, fall back to request IP-based location logic.
   *
   * @generated from field: optional qb.smg.GeoPoint user_location = 1;
   */
  userLocation?: GeoPoint;

  /**
   * Search text from the Location Finder input.
   * Applied to venue name, organization name, city, state, and ZIP/postal code.
   *
   * @generated from field: optional string query = 2;
   */
  query?: string;

  /**
   * Requested venue sort.
   *
   * @generated from field: qb.smg.LocationFinderSort sort = 3;
   */
  sort: LocationFinderSort;

  /**
   * If true, return only venues with activity happening now.
   *
   * @generated from field: optional bool active_now_only = 4;
   */
  activeNowOnly?: boolean;

  /**
   * If true, return only venues marked as hot.
   *
   * @generated from field: optional bool hot_only = 5;
   */
  hotOnly?: boolean;

  /**
   * Brand/operator filter ids selected by the user.
   *
   * @generated from field: repeated string brand_filter_ids = 6;
   */
  brandFilterIds: string[];
};

/**
 * Describes the message qb.smg.GetLocationFinderVenuesRequest.
 * Use `create(GetLocationFinderVenuesRequestSchema)` to create a new message.
 */
export const GetLocationFinderVenuesRequestSchema: GenMessage<GetLocationFinderVenuesRequest> = /*@__PURE__*/
  messageDesc(file_smg_public_api, 14);

/**
 * @generated from message qb.smg.GetLocationFinderVenuesReply
 */
export type GetLocationFinderVenuesReply = Message<"qb.smg.GetLocationFinderVenuesReply"> & {
  /**
   * One item per venue.
   *
   * @generated from field: repeated qb.smg.LocationFinderVenue venues = 1;
   */
  venues: LocationFinderVenue[];

  /**
   * Brand/operator filter options available for the Location Finder chips.
   *
   * @generated from field: repeated qb.smg.LocationFinderBrandFilter brand_filters = 2;
   */
  brandFilters: LocationFinderBrandFilter[];
};

/**
 * Describes the message qb.smg.GetLocationFinderVenuesReply.
 * Use `create(GetLocationFinderVenuesReplySchema)` to create a new message.
 */
export const GetLocationFinderVenuesReplySchema: GenMessage<GetLocationFinderVenuesReply> = /*@__PURE__*/
  messageDesc(file_smg_public_api, 15);

/**
 * @generated from message qb.smg.LocationFinderVenue
 */
export type LocationFinderVenue = Message<"qb.smg.LocationFinderVenue"> & {
  /**
   * Legacy venue id. 0 when the venue has no legacy id; use venue_uuid as the stable id.
   *
   * @generated from field: int32 venue_id = 1;
   */
  venueId: number;

  /**
   * Venue card title.
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * Venue card address.
   *
   * @generated from field: string address = 3;
   */
  address: string;

  /**
   * Venue card city.
   *
   * @generated from field: string city = 4;
   */
  city: string;

  /**
   * Venue card state/region, for example "NV".
   *
   * @generated from field: string state = 5;
   */
  state: string;

  /**
   * Used for map marker placement.
   *
   * @generated from field: qb.smg.GeoPoint location = 6;
   */
  location?: GeoPoint;

  /**
   * Distance from user_location or IP-based fallback location in miles.
   *
   * @generated from field: optional double distance_miles = 7;
   */
  distanceMiles?: number;

  /**
   * Number of Evenplay-enabled bays/simulators at this venue.
   *
   * @generated from field: int32 bays_count = 8;
   */
  baysCount: number;

  /**
   * Used for activity label, active marker state, Active now filter, and Most active sort.
   *
   * @generated from field: qb.smg.VenueActivityStatus activity_status = 9;
   */
  activityStatus: VenueActivityStatus;

  /**
   * Used for brand/operator filter chips.
   *
   * @generated from field: optional string brand = 10;
   */
  brand?: string;

  /**
   * Used for Hot badge and Hot filter.
   *
   * @generated from field: optional bool is_hot = 11;
   */
  isHot?: boolean;

  /**
   * Used for expandable Top Players preview inside the venue card.
   *
   * @generated from field: repeated qb.smg.LocationFinderTopPlayer top_players_preview = 12;
   */
  topPlayersPreview: LocationFinderTopPlayer[];

  /**
   * Name of the organization that operates the venue, separate from the venue name.
   *
   * @generated from field: string organization_name = 13;
   */
  organizationName: string;

  /**
   * Venue phone number, when the venue has one.
   *
   * @generated from field: optional string phone = 14;
   */
  phone?: string;

  /**
   * Venue booking URL, when the venue has one.
   *
   * @generated from field: optional string booking_url = 15;
   */
  bookingUrl?: string;

  /**
   * Stable venue id.
   *
   * @generated from field: string venue_uuid = 16;
   */
  venueUuid: string;
};

/**
 * Describes the message qb.smg.LocationFinderVenue.
 * Use `create(LocationFinderVenueSchema)` to create a new message.
 */
export const LocationFinderVenueSchema: GenMessage<LocationFinderVenue> = /*@__PURE__*/
  messageDesc(file_smg_public_api, 16);

/**
 * @generated from message qb.smg.LocationFinderBrandFilter
 */
export type LocationFinderBrandFilter = Message<"qb.smg.LocationFinderBrandFilter"> & {
  /**
   * Stable public filter id used in requests.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Display label shown in the UI chip.
   *
   * @generated from field: string label = 2;
   */
  label: string;
};

/**
 * Describes the message qb.smg.LocationFinderBrandFilter.
 * Use `create(LocationFinderBrandFilterSchema)` to create a new message.
 */
export const LocationFinderBrandFilterSchema: GenMessage<LocationFinderBrandFilter> = /*@__PURE__*/
  messageDesc(file_smg_public_api, 17);

/**
 * @generated from message qb.smg.GeoPoint
 */
export type GeoPoint = Message<"qb.smg.GeoPoint"> & {
  /**
   * @generated from field: double latitude = 1;
   */
  latitude: number;

  /**
   * @generated from field: double longitude = 2;
   */
  longitude: number;
};

/**
 * Describes the message qb.smg.GeoPoint.
 * Use `create(GeoPointSchema)` to create a new message.
 */
export const GeoPointSchema: GenMessage<GeoPoint> = /*@__PURE__*/
  messageDesc(file_smg_public_api, 18);

/**
 * @generated from message qb.smg.LocationFinderTopPlayer
 */
export type LocationFinderTopPlayer = Message<"qb.smg.LocationFinderTopPlayer"> & {
  /**
   * @generated from field: int32 rank = 1;
   */
  rank: number;

  /**
   * @generated from field: string player_display_name = 2;
   */
  playerDisplayName: string;

  /**
   * @generated from field: string amount_display = 3;
   */
  amountDisplay: string;
};

/**
 * Describes the message qb.smg.LocationFinderTopPlayer.
 * Use `create(LocationFinderTopPlayerSchema)` to create a new message.
 */
export const LocationFinderTopPlayerSchema: GenMessage<LocationFinderTopPlayer> = /*@__PURE__*/
  messageDesc(file_smg_public_api, 19);

/**
 * @generated from message qb.smg.SubmitContactInquiryRequest
 */
export type SubmitContactInquiryRequest = Message<"qb.smg.SubmitContactInquiryRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: optional string phone = 2;
   */
  phone?: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: optional string work_email = 4;
   */
  workEmail?: string;

  /**
   * @generated from field: string message = 5;
   */
  message: string;
};

/**
 * Describes the message qb.smg.SubmitContactInquiryRequest.
 * Use `create(SubmitContactInquiryRequestSchema)` to create a new message.
 */
export const SubmitContactInquiryRequestSchema: GenMessage<SubmitContactInquiryRequest> = /*@__PURE__*/
  messageDesc(file_smg_public_api, 20);

/**
 * @generated from message qb.smg.SubmitContactInquiryReply
 */
export type SubmitContactInquiryReply = Message<"qb.smg.SubmitContactInquiryReply"> & {
  /**
   * @generated from field: string inquiry_id = 1;
   */
  inquiryId: string;
};

/**
 * Describes the message qb.smg.SubmitContactInquiryReply.
 * Use `create(SubmitContactInquiryReplySchema)` to create a new message.
 */
export const SubmitContactInquiryReplySchema: GenMessage<SubmitContactInquiryReply> = /*@__PURE__*/
  messageDesc(file_smg_public_api, 21);

/**
 * @generated from message qb.smg.GetTopPlayersLeaderboardRequest
 */
export type GetTopPlayersLeaderboardRequest = Message<"qb.smg.GetTopPlayersLeaderboardRequest"> & {
  /**
   * User location from browser geolocation.
   * If absent, resolve the location from the request IP address.
   *
   * @generated from field: optional qb.smg.GeoPoint user_location = 1;
   */
  userLocation?: GeoPoint;

  /**
   * Geographic scope selected in the Top Players tab.
   *
   * @generated from field: qb.smg.TopPlayersLeaderboardScope scope = 2;
   */
  scope: TopPlayersLeaderboardScope;

  /**
   * Leaderboard period selected in the Top Players tab.
   *
   * @generated from field: qb.smg.TopPlayersLeaderboardPeriod period = 3;
   */
  period: TopPlayersLeaderboardPeriod;
};

/**
 * Describes the message qb.smg.GetTopPlayersLeaderboardRequest.
 * Use `create(GetTopPlayersLeaderboardRequestSchema)` to create a new message.
 */
export const GetTopPlayersLeaderboardRequestSchema: GenMessage<GetTopPlayersLeaderboardRequest> = /*@__PURE__*/
  messageDesc(file_smg_public_api, 22);

/**
 * @generated from message qb.smg.GetTopPlayersLeaderboardReply
 */
export type GetTopPlayersLeaderboardReply = Message<"qb.smg.GetTopPlayersLeaderboardReply"> & {
  /**
   * Display-ready label for the resolved leaderboard context.
   * Examples: "Topgolf Las Vegas", "Las Vegas, NV", or "Global".
   *
   * @generated from field: string context_label = 1;
   */
  contextLabel: string;

  /**
   * Top leaderboard entries ordered by rank.
   *
   * @generated from field: repeated qb.smg.TopPlayersLeaderboardEntry entries = 2;
   */
  entries: TopPlayersLeaderboardEntry[];
};

/**
 * Describes the message qb.smg.GetTopPlayersLeaderboardReply.
 * Use `create(GetTopPlayersLeaderboardReplySchema)` to create a new message.
 */
export const GetTopPlayersLeaderboardReplySchema: GenMessage<GetTopPlayersLeaderboardReply> = /*@__PURE__*/
  messageDesc(file_smg_public_api, 23);

/**
 * @generated from message qb.smg.TopPlayersLeaderboardEntry
 */
export type TopPlayersLeaderboardEntry = Message<"qb.smg.TopPlayersLeaderboardEntry"> & {
  /**
   * Backend-calculated player position in the selected leaderboard.
   * A value of 1 represents first place.
   *
   * @generated from field: int32 rank = 1;
   */
  rank: number;

  /**
   * Display-ready public initials shown in the player avatar.
   * Example: "MT".
   *
   * @generated from field: string player_initials = 2;
   */
  playerInitials: string;

  /**
   * Display-ready player name formatted according to the
   * public leaderboard name policy.
   * Example: "Marcus T.".
   *
   * @generated from field: string player_display_name = 3;
   */
  playerDisplayName: string;

  /**
   * Challenge count associated with this entry for the
   * requested scope and period.
   *
   * @generated from field: int32 challenges_count = 4;
   */
  challengesCount: number;

  /**
   * Display state for the backend-calculated rank change.
   * UP renders as ▲, DOWN as ▼, and SAME as —.
   * Always UNSPECIFIED for the ALL_TIME period — there is no prior all-time
   * period to compare against (product decision, SMG-3776 Q&A #5: the UI
   * drops the rank-change column entirely for All-Time rather than always
   * rendering a dash).
   *
   * @generated from field: qb.smg.TopPlayersRankChangeDirection rank_change_direction = 5;
   */
  rankChangeDirection: TopPlayersRankChangeDirection;

  /**
   * Backend-calculated winnings amount formatted for public display.
   * Example: "$45,000".
   *
   * @generated from field: string winnings_amount_display = 6;
   */
  winningsAmountDisplay: string;
};

/**
 * Describes the message qb.smg.TopPlayersLeaderboardEntry.
 * Use `create(TopPlayersLeaderboardEntrySchema)` to create a new message.
 */
export const TopPlayersLeaderboardEntrySchema: GenMessage<TopPlayersLeaderboardEntry> = /*@__PURE__*/
  messageDesc(file_smg_public_api, 24);

/**
 * PublicFeedScopeFilter selects one rung of the PublicFeedScope projection plus
 * the value identifying that rung. Only coarse geo rungs exist (no bay/venue).
 * scope_value semantics per rung:
 *   CITY    -> "City, ST" (comma + space; uppercase two-letter state; the city
 *              token is matched case-insensitively), e.g. "Denver, CO"
 *   STATE   -> two-letter state/region code, e.g. "CO"
 *   COUNTRY -> ISO-3166 alpha-2 country code, e.g. "US"
 *   GLOBAL / UNSPECIFIED -> empty (whole network)
 * An unrecognized rung or malformed scope_value MUST fail closed
 * (INVALID_ARGUMENT); a server MUST NOT fall back to a broader scope.
 *
 * @generated from message qb.smg.PublicFeedScopeFilter
 */
export type PublicFeedScopeFilter = Message<"qb.smg.PublicFeedScopeFilter"> & {
  /**
   * @generated from field: qb.smg.PublicFeedScope scope = 1;
   */
  scope: PublicFeedScope;

  /**
   * @generated from field: string scope_value = 2;
   */
  scopeValue: string;
};

/**
 * Describes the message qb.smg.PublicFeedScopeFilter.
 * Use `create(PublicFeedScopeFilterSchema)` to create a new message.
 */
export const PublicFeedScopeFilterSchema: GenMessage<PublicFeedScopeFilter> = /*@__PURE__*/
  messageDesc(file_smg_public_api, 25);

/**
 * @generated from message qb.smg.GetRecentHoleInOnesRequest
 */
export type GetRecentHoleInOnesRequest = Message<"qb.smg.GetRecentHoleInOnesRequest"> & {
  /**
   * Region filter. Absent / UNSPECIFIED scope is treated as GLOBAL.
   *
   * @generated from field: qb.smg.PublicFeedScopeFilter scope_filter = 1;
   */
  scopeFilter?: PublicFeedScopeFilter;

  /**
   * Optional page-size cap; clamped server-side like GetRecentWins.
   *
   * @generated from field: optional int32 limit = 2;
   */
  limit?: number;
};

/**
 * Describes the message qb.smg.GetRecentHoleInOnesRequest.
 * Use `create(GetRecentHoleInOnesRequestSchema)` to create a new message.
 */
export const GetRecentHoleInOnesRequestSchema: GenMessage<GetRecentHoleInOnesRequest> = /*@__PURE__*/
  messageDesc(file_smg_public_api, 26);

/**
 * @generated from message qb.smg.GetRecentHoleInOnesReply
 */
export type GetRecentHoleInOnesReply = Message<"qb.smg.GetRecentHoleInOnesReply"> & {
  /**
   * @generated from field: repeated qb.smg.RecentHoleInOne hole_in_ones = 1;
   */
  holeInOnes: RecentHoleInOne[];
};

/**
 * Describes the message qb.smg.GetRecentHoleInOnesReply.
 * Use `create(GetRecentHoleInOnesReplySchema)` to create a new message.
 */
export const GetRecentHoleInOnesReplySchema: GenMessage<GetRecentHoleInOnesReply> = /*@__PURE__*/
  messageDesc(file_smg_public_api, 27);

/**
 * @generated from message qb.smg.RecentHoleInOne
 */
export type RecentHoleInOne = Message<"qb.smg.RecentHoleInOne"> & {
  /**
   * Opaque, stable, non-sequential public id; identical across polls, snapshot
   * refreshes, and across BOTH feeds (suitable for client dedup / render keys).
   * MUST NOT be the internal bet/row primary key.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Masked per the GetRecentWins contract (server-side maskPlayerDisplayName):
   * never reveals a complete real-name token. The masking algorithm lives
   * server-side and may evolve; the never-a-complete-token invariant is the
   * contract.
   *
   * @generated from field: string player_display_name = 2;
   */
  playerDisplayName: string;

  /**
   * @generated from field: string venue_name = 3;
   */
  venueName: string;

  /**
   * @generated from field: string city = 4;
   */
  city: string;

  /**
   * @generated from field: string state = 5;
   */
  state: string;

  /**
   * Venue-local calendar date, "YYYY-MM-DD". Date-only BY DESIGN: this is the
   * unauthenticated, highly-masked public tier, and a hole-in-one is a rare,
   * publicly-witnessed event — second-precise time + venue + amount would be a
   * de-anonymization join key. Precise timestamps belong to the future
   * authenticated tier only. Entries are server-ordered newest-first.
   *
   * @generated from field: string occurred_on = 6;
   */
  occurredOn: string;

  /**
   * Product-approved formatted display string (e.g. "$1,000"). Rounded/bucketed
   * for public display; MUST NOT carry sub-dollar precision or raw cents. Raw
   * amounts are never exposed on this surface (cf. Activity.wonAmount, which is
   * deprecated for exactly this reason).
   *
   * @generated from field: string amount_display = 7;
   */
  amountDisplay: string;
};

/**
 * Describes the message qb.smg.RecentHoleInOne.
 * Use `create(RecentHoleInOneSchema)` to create a new message.
 */
export const RecentHoleInOneSchema: GenMessage<RecentHoleInOne> = /*@__PURE__*/
  messageDesc(file_smg_public_api, 28);

/**
 * @generated from message qb.smg.GetRecentHighlightsRequest
 */
export type GetRecentHighlightsRequest = Message<"qb.smg.GetRecentHighlightsRequest"> & {
  /**
   * Region filter. Absent / UNSPECIFIED scope is treated as GLOBAL.
   *
   * @generated from field: qb.smg.PublicFeedScopeFilter scope_filter = 1;
   */
  scopeFilter?: PublicFeedScopeFilter;

  /**
   * Optional page-size cap; clamped server-side like GetRecentWins.
   *
   * @generated from field: optional int32 limit = 2;
   */
  limit?: number;
};

/**
 * Describes the message qb.smg.GetRecentHighlightsRequest.
 * Use `create(GetRecentHighlightsRequestSchema)` to create a new message.
 */
export const GetRecentHighlightsRequestSchema: GenMessage<GetRecentHighlightsRequest> = /*@__PURE__*/
  messageDesc(file_smg_public_api, 29);

/**
 * @generated from message qb.smg.GetRecentHighlightsReply
 */
export type GetRecentHighlightsReply = Message<"qb.smg.GetRecentHighlightsReply"> & {
  /**
   * @generated from field: repeated qb.smg.RecentHighlight highlights = 1;
   */
  highlights: RecentHighlight[];
};

/**
 * Describes the message qb.smg.GetRecentHighlightsReply.
 * Use `create(GetRecentHighlightsReplySchema)` to create a new message.
 */
export const GetRecentHighlightsReplySchema: GenMessage<GetRecentHighlightsReply> = /*@__PURE__*/
  messageDesc(file_smg_public_api, 30);

/**
 * @generated from message qb.smg.RecentHighlight
 */
export type RecentHighlight = Message<"qb.smg.RecentHighlight"> & {
  /**
   * Opaque, stable, non-sequential public id (see RecentHoleInOne.id). The same
   * ace carries the same id in both feeds.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Masked per the GetRecentWins contract (see RecentHoleInOne).
   *
   * @generated from field: string player_display_name = 2;
   */
  playerDisplayName: string;

  /**
   * @generated from field: string venue_name = 3;
   */
  venueName: string;

  /**
   * @generated from field: string city = 4;
   */
  city: string;

  /**
   * @generated from field: string state = 5;
   */
  state: string;

  /**
   * Venue-local calendar date, "YYYY-MM-DD". Date-only BY DESIGN (see
   * RecentHoleInOne.occurred_on) — the public tier is uniformly coarse so a
   * precise ace time cannot leak through the blended feed. Server-ordered
   * newest-first.
   *
   * @generated from field: string occurred_on = 6;
   */
  occurredOn: string;

  /**
   * Product-approved formatted display string (see RecentHoleInOne.amount_display).
   *
   * @generated from field: string amount_display = 7;
   */
  amountDisplay: string;

  /**
   * Flags, not an enum: an ace can also be a big payout, so an entry may set
   * both.
   *
   * @generated from field: bool is_hole_in_one = 8;
   */
  isHoleInOne: boolean;

  /**
   * @generated from field: bool is_big_win = 9;
   */
  isBigWin: boolean;
};

/**
 * Describes the message qb.smg.RecentHighlight.
 * Use `create(RecentHighlightSchema)` to create a new message.
 */
export const RecentHighlightSchema: GenMessage<RecentHighlight> = /*@__PURE__*/
  messageDesc(file_smg_public_api, 31);

/**
 * @generated from enum qb.smg.LocationFinderSort
 */
export enum LocationFinderSort {
  /**
   * @generated from enum value: LOCATION_FINDER_SORT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: LOCATION_FINDER_SORT_NEAREST = 1;
   */
  NEAREST = 1,

  /**
   * @generated from enum value: LOCATION_FINDER_SORT_MOST_ACTIVE = 2;
   */
  MOST_ACTIVE = 2,

  /**
   * @generated from enum value: LOCATION_FINDER_SORT_MOST_BAYS = 3;
   */
  MOST_BAYS = 3,
}

/**
 * Describes the enum qb.smg.LocationFinderSort.
 */
export const LocationFinderSortSchema: GenEnum<LocationFinderSort> = /*@__PURE__*/
  enumDesc(file_smg_public_api, 0);

/**
 * @generated from enum qb.smg.VenueActivityStatus
 */
export enum VenueActivityStatus {
  /**
   * @generated from enum value: VENUE_ACTIVITY_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: VENUE_ACTIVITY_STATUS_ACTIVE_NOW = 1;
   */
  ACTIVE_NOW = 1,

  /**
   * @generated from enum value: VENUE_ACTIVITY_STATUS_ACTIVE_TODAY = 2;
   */
  ACTIVE_TODAY = 2,

  /**
   * @generated from enum value: VENUE_ACTIVITY_STATUS_ACTIVE_THIS_WEEK = 3;
   */
  ACTIVE_THIS_WEEK = 3,
}

/**
 * Describes the enum qb.smg.VenueActivityStatus.
 */
export const VenueActivityStatusSchema: GenEnum<VenueActivityStatus> = /*@__PURE__*/
  enumDesc(file_smg_public_api, 1);

/**
 * @generated from enum qb.smg.TopPlayersLeaderboardScope
 */
export enum TopPlayersLeaderboardScope {
  /**
   * @generated from enum value: TOP_PLAYERS_LEADERBOARD_SCOPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TOP_PLAYERS_LEADERBOARD_SCOPE_VENUE = 1;
   */
  VENUE = 1,

  /**
   * @generated from enum value: TOP_PLAYERS_LEADERBOARD_SCOPE_CITY = 2;
   */
  CITY = 2,

  /**
   * @generated from enum value: TOP_PLAYERS_LEADERBOARD_SCOPE_STATE = 3;
   */
  STATE = 3,

  /**
   * @generated from enum value: TOP_PLAYERS_LEADERBOARD_SCOPE_COUNTRY = 4;
   */
  COUNTRY = 4,

  /**
   * @generated from enum value: TOP_PLAYERS_LEADERBOARD_SCOPE_WORLD = 5;
   */
  WORLD = 5,
}

/**
 * Describes the enum qb.smg.TopPlayersLeaderboardScope.
 */
export const TopPlayersLeaderboardScopeSchema: GenEnum<TopPlayersLeaderboardScope> = /*@__PURE__*/
  enumDesc(file_smg_public_api, 2);

/**
 * @generated from enum qb.smg.TopPlayersLeaderboardPeriod
 */
export enum TopPlayersLeaderboardPeriod {
  /**
   * @generated from enum value: TOP_PLAYERS_LEADERBOARD_PERIOD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TOP_PLAYERS_LEADERBOARD_PERIOD_WEEK = 1;
   */
  WEEK = 1,

  /**
   * @generated from enum value: TOP_PLAYERS_LEADERBOARD_PERIOD_MONTH = 2;
   */
  MONTH = 2,

  /**
   * @generated from enum value: TOP_PLAYERS_LEADERBOARD_PERIOD_YEAR = 3;
   */
  YEAR = 3,

  /**
   * @generated from enum value: TOP_PLAYERS_LEADERBOARD_PERIOD_ALL_TIME = 4;
   */
  ALL_TIME = 4,
}

/**
 * Describes the enum qb.smg.TopPlayersLeaderboardPeriod.
 */
export const TopPlayersLeaderboardPeriodSchema: GenEnum<TopPlayersLeaderboardPeriod> = /*@__PURE__*/
  enumDesc(file_smg_public_api, 3);

/**
 * @generated from enum qb.smg.TopPlayersRankChangeDirection
 */
export enum TopPlayersRankChangeDirection {
  /**
   * @generated from enum value: TOP_PLAYERS_RANK_CHANGE_DIRECTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TOP_PLAYERS_RANK_CHANGE_DIRECTION_UP = 1;
   */
  UP = 1,

  /**
   * @generated from enum value: TOP_PLAYERS_RANK_CHANGE_DIRECTION_DOWN = 2;
   */
  DOWN = 2,

  /**
   * @generated from enum value: TOP_PLAYERS_RANK_CHANGE_DIRECTION_SAME = 3;
   */
  SAME = 3,
}

/**
 * Describes the enum qb.smg.TopPlayersRankChangeDirection.
 */
export const TopPlayersRankChangeDirectionSchema: GenEnum<TopPlayersRankChangeDirection> = /*@__PURE__*/
  enumDesc(file_smg_public_api, 4);

/**
 * PublicFeedScope is the PUBLIC geo-scope projection for the masked public
 * feeds — coarse geography only (city and up). It is intentionally a STRICT
 * SUBSET of the internal SMG-3491 geo tiers: the finer bay/venue rungs are
 * NOT exposed on the unauthenticated public surface, because per-location
 * slicing of masked gambling data is a de-anonymization / surveillance risk.
 * SMG-3775 launches on STATE and CITY.
 *
 * This is a public projection, not a shared vocabulary mandate: when SMG-3491
 * lands it owns its own (richer, non-linear) scope enum; this enum does not
 * require it to reuse these values.
 *
 * @generated from enum qb.smg.PublicFeedScope
 */
export enum PublicFeedScope {
  /**
   * treated as GLOBAL (whole network)
   *
   * @generated from enum value: PUBLIC_FEED_SCOPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PUBLIC_FEED_SCOPE_CITY = 1;
   */
  CITY = 1,

  /**
   * @generated from enum value: PUBLIC_FEED_SCOPE_STATE = 2;
   */
  STATE = 2,

  /**
   * @generated from enum value: PUBLIC_FEED_SCOPE_COUNTRY = 3;
   */
  COUNTRY = 3,

  /**
   * @generated from enum value: PUBLIC_FEED_SCOPE_GLOBAL = 4;
   */
  GLOBAL = 4,
}

/**
 * Describes the enum qb.smg.PublicFeedScope.
 */
export const PublicFeedScopeSchema: GenEnum<PublicFeedScope> = /*@__PURE__*/
  enumDesc(file_smg_public_api, 5);

/**
 * @generated from service qb.smg.PublicApiService
 */
export const PublicApiService: GenService<{
  /**
   * @generated from rpc qb.smg.PublicApiService.StreamTournamentUpdates
   */
  streamTournamentUpdates: {
    methodKind: "server_streaming";
    input: typeof StreamTournamentUpdatesRequestSchema;
    output: typeof StreamTournamentUpdatesReplySchema;
  },
  /**
   * @generated from rpc qb.smg.PublicApiService.GetNearestSimulators
   */
  getNearestSimulators: {
    methodKind: "unary";
    input: typeof GetNearestSimulatorsRequestSchema;
    output: typeof GetNearestSimulatorsReplySchema;
  },
  /**
   * @generated from rpc qb.smg.PublicApiService.GetNearestActivities
   */
  getNearestActivities: {
    methodKind: "unary";
    input: typeof GetNearestActivitiesRequestSchema;
    output: typeof GetNearestActivitiesReplySchema;
  },
  /**
   * @generated from rpc qb.smg.PublicApiService.GetRecentWins
   */
  getRecentWins: {
    methodKind: "unary";
    input: typeof GetRecentWinsRequestSchema;
    output: typeof GetRecentWinsReplySchema;
  },
  /**
   * @generated from rpc qb.smg.PublicApiService.GetLocationFinderVenues
   */
  getLocationFinderVenues: {
    methodKind: "unary";
    input: typeof GetLocationFinderVenuesRequestSchema;
    output: typeof GetLocationFinderVenuesReplySchema;
  },
  /**
   * @generated from rpc qb.smg.PublicApiService.SubmitContactInquiry
   */
  submitContactInquiry: {
    methodKind: "unary";
    input: typeof SubmitContactInquiryRequestSchema;
    output: typeof SubmitContactInquiryReplySchema;
  },
  /**
   * GetTopPlayersLeaderboard serves the /play page's Top Players tab: a single
   * leaderboard for the caller-selected geographic scope and period.
   *
   * @generated from rpc qb.smg.PublicApiService.GetTopPlayersLeaderboard
   */
  getTopPlayersLeaderboard: {
    methodKind: "unary";
    input: typeof GetTopPlayersLeaderboardRequestSchema;
    output: typeof GetTopPlayersLeaderboardReplySchema;
  },
  /**
   * GetRecentHoleInOnes serves the Golf.com public hole-in-one feed. Region
   * scoping reuses the shared PublicFeedScope ladder (Golf.com uses STATE and
   * CITY). Player display names are masked (see RecentHoleInOne).
   *
   * @generated from rpc qb.smg.PublicApiService.GetRecentHoleInOnes
   */
  getRecentHoleInOnes: {
    methodKind: "unary";
    input: typeof GetRecentHoleInOnesRequestSchema;
    output: typeof GetRecentHoleInOnesReplySchema;
  },
  /**
   * GetRecentHighlights serves the blended big-wins + hole-in-ones feed. Each
   * entry carries both is_hole_in_one and is_big_win flags (an ace can also be
   * a big payout — flags, not an enum).
   *
   * @generated from rpc qb.smg.PublicApiService.GetRecentHighlights
   */
  getRecentHighlights: {
    methodKind: "unary";
    input: typeof GetRecentHighlightsRequestSchema;
    output: typeof GetRecentHighlightsReplySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_smg_public_api, 0);

